<script>
  import { onMount } from 'svelte';
  import SEO from '$lib/components/SEO.svelte';
  import Header from '$lib/components/Header.svelte';
  import Footer from '$lib/components/Footer.svelte';
  import PageHero from '$lib/components/PageHero.svelte';
  import Container from '$lib/components/Container.svelte';
  import LinkButton from '$lib/components/LinkButton.svelte';
  
  // Props from the server
  export let data;
  const allPages = data.allPages;
  
  // Page metadata
  const pageTitle = "Location Name Pickers | Browse All Location Pages";
  const pageDescription = "Browse our complete collection of location name pickers. Find the perfect random selector for your location-specific needs.";
</script>

<SEO title={pageTitle} description={pageDescription} />

<PageHero 
  title="Browse Location Name Pickers"
  subtitle="Find the perfect random selector for your location-specific needs"
/>

<Container>
  <div class="py-12">
    <h2 class="text-2xl font-bold mb-6">All Location Name Pickers</h2>
    
    <p class="mb-8">
      Explore our complete collection of location-specific random name pickers. 
      Click on any option below to find the perfect tool for your needs.
    </p>
    
    {#if allPages.length > 0}
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {#each allPages as page}
          <a 
            href="/{page.type}/{page.slug}" 
            class="p-4 border rounded-lg hover:bg-gray-50 transition-colors"
          >
            <h3 class="font-semibold text-lg text-blue-600">{page.title}</h3>
          </a>
        {/each}
      </div>
    {:else}
      <div class="p-8 text-center bg-gray-50 rounded-lg border border-gray-200">
        <h3 class="text-xl font-semibold text-gray-700 mb-2">Location-specific tools coming soon!</h3>
        <p class="text-gray-600 mb-4">
          We're currently developing location-specific name pickers. Check back soon for tools designed for educators in your area.
        </p>
      </div>
    {/if}
    
    <div class="mt-12 text-center">
      <LinkButton href="/directory">Browse More Categories</LinkButton>
    </div>
  </div>
</Container>

<Footer />
